export default "__VITE_ASSET__KQO8Bwdq__"